module.exports = __webpack_public_path__ + "static/media/LazyAz_android_1.f1436b15.jpg";